import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { CommonService } from '../../../services/common/common.service';
import { MasterConstants } from '../../constants/master-constants';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})

export class ConfirmDialogComponent implements OnInit {
  isNotValid = false;
  emails: string;
  comments: string;
  /* emailPattern: any = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;*/
  // emailPattern: any = MasterConstants.EMAIL_PATTERN;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  dialogType: string;
  deliveryDate: any;
  dateFilter: (d: Date) => boolean;
  defaultEmail = '';
  isEmailIdEmpty = false;
  matcher = new InputErrorStateMatcher(this.isNotValid);
  isShowMsg = false;
  title: string;

  isValidCirImportedFileName: boolean = false;
  cirImportedFile: any;
  isCirFileError: boolean = false;
  cirErrorMessage: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private commonService: CommonService) {
    this.dialogType = this.data.dialogType;
    this.deliveryDate = new Date();
    this.deliveryDate.setDate(this.deliveryDate.getDate() + this.data.deliveryDate);
    this.emails = this.data.dialogType == 'priceListEmail' ? '' : this.data.email;
    this.defaultEmail = this.defaultEmail + this.data.email;
    this.data.actionYes = true;
    this.title = this.data.title;
    if (this.data.isYesEnable != undefined) {
      this.data.isYesEnable = this.data.isYesEnable;
    }
    else {
      this.data.isYesEnable = true;
    }
  }

  ngOnInit() {
    this.validateDateFilter();
  }

  onNoAction(): void {
    this.dialogRef.close();
  }

  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.emails, true);
  }

  sendEmail(value: string) {
    if (!this.isNotValid) {
      value = this.data.dialogType == 'priceListEmail' ? this.data.email + ';' + value : value;
      this.dialogRef.close(value);
    }
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;// .getDate();
      return calendarDate >= currentDate; // && calendarDate <= maxDate;
    };
  }

  sendDate(value: string) {
    this.dialogRef.close(value);
  }

  updateStatus(comments: string, status: string) {
    if ((comments == null || comments == undefined) && status !== 'Approved') {
    } else {
      const updateData = { comments: comments, status: status };
      this.dialogRef.close(updateData);
    }
  }

  SOTUpdateRequest(comments: string, status: string) {
    if (comments != null && comments != undefined && comments != '') {
      const updateData = { comments: comments, status: status };
      this.dialogRef.close(updateData);
    } else {
      this.isShowMsg = true;
    }
  }

  COTUpdateRequest(comments: string, status: string) {
    if (comments != null && comments != undefined && comments != '') {
      const updateData = { comments: comments, status: status };
      this.dialogRef.close(updateData);
    } else {
      this.isShowMsg = true;
    }
  }

  onFileSelect(event, dialogData) {
    let af = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      dialogData.message = '';
      dialogData.importFileData = file;
      if (!af.includes(file.type)) {
        this.isCirFileError = true;
        this.cirErrorMessage = 'Only Excel sheet file types allowed';
      } else {
        this.isCirFileError = false;
        this.isValidCirImportedFileName = true;
        this.cirImportedFile = file;
      }
    }
  }

  validateColumnsAndLoadData() {
    var dailogInput = {
      importFileData: this.cirImportedFile
    }
    this.dialogRef.close(dailogInput);
  }

  removeFileSelection(dialogData) {
    dialogData.message = '';
    dialogData.importFileData = null;
    this.isCirFileError = false;
    this.isValidCirImportedFileName = false;
    this.cirImportedFile = null;
  }

  closeCIRPopupAction() {
    this.cirImportedFile = null;
    var dailogInput = {
      importFileData: this.cirImportedFile
    }
    this.dialogRef.close(dailogInput);
  }

  onSurveyResponse(pref: string) {
    this.dialogRef.close(pref);
  }
}

export interface DialogData {
  title: string;
  message: string;
  htmlMessage: string;
  actionYes: boolean;
  labelYes: string;
  labelNo: string;
  isYesEnable: boolean;
  email: string;
  tabNode: boolean;
  dialogType: string;
  deliveryDate: number;
  rows: number;
  quoteNumber: string;
  preparedFor: string;
}

class InputErrorStateMatcher implements ErrorStateMatcher {
  constructor(private errorstate: boolean) { }
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return this.errorstate;
  }
}
